// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4402":"c2e76bd4a96e642e","5894":"750b787dfd1687bc","7310":"b9cbe628f8cd1484"}[chunkId] + ".js";
};